import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PolicyViewHeaderContextValue {
  showEditPolicyButton: boolean;
  setShowEditPolicyButton: (show: boolean) => void;
}

const PolicyViewHeaderContext = createContext<PolicyViewHeaderContextValue | null>(null);

export function PolicyViewHeaderProvider({ children }: { children: ReactNode }) {
  const [showEditPolicyButton, setShowEditPolicyButton] = useState(true);
  return (
    <PolicyViewHeaderContext.Provider value={{ showEditPolicyButton, setShowEditPolicyButton }}>
      {children}
    </PolicyViewHeaderContext.Provider>
  );
}

export function usePolicyViewHeader() {
  const ctx = useContext(PolicyViewHeaderContext);
  return ctx;
}
